import React from 'react';

export const MapContext = React.createContext({
    items: [],
    setItems: () => undefined,
    currentKey: null,
    setCurrentKey: () => undefined,
});

export const MapContextProvider = (props) => {
    const [items, setItems] = React.useState([]);
    const [currentKey, setCurrentKey] = React.useState(0);

    return (
        <MapContext.Provider
            value={{
                items,
                setItems,
                currentKey,
                setCurrentKey,
            }}
            {...props}
        />
    );
};

export const useMapContext = () => {
    const context = React.useContext(MapContext);

    if (context == null) {
        throw new Error('`useMapContext` needs to be used within `MapContext`');
    }

    return context;
};
